import { styled } from "styled-components";

export const PageHeader = styled.div`
	padding: 20px 0;

	.topHeader {
		margin-bottom: 28px;
		justify-content: space-between;

		.profileTypeBtn {
			flex-shrink: 0;
			width: fit-content;
			padding: 8px 23px;
			margin-right: 10px;
			font-weight: 500;
			font-size: 15px;
			color: #888;
			cursor: pointer;

			&.active {
				background: #eff8f9;
				border-radius: 20px;
				color: #333;
			}
		}
	}

	.createAsset {
		.sortHeader {
			width: 100%;

			.sortBy {
				justify-self: flex-end;
			}
		}
	}
`;

export const CardWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 12px 0;
	margin-bottom: ${(props) => (props.custommargin ? props.custommargin : "36px")};

	.chartCard,
	& > div {
		width: ${(props) => (props.customwidth ? props.customwidth : "48%")};
		padding-left: 20px;
		padding-right: 20px;
	}
`;

export const SectionWrapper = styled.div`
	h3 {
		font-weight: 600;
		font-size: 20px;
		padding-bottom: 16px;
	}
	border: 1px solid #b8c8cf;
	box-shadow: 0px 10px 50px 0px #0067700d;
	padding: 24px 18px;
	border-radius: 8px;
`;
